import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { useCreateOS } from "../../../../../components/WMS/SalesOffers/useCreateOS"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

type Search = {
  warehouseId?: string
}

type RawSearch = {
  warehouseId?: unknown
}

export const Route = createFileRoute("/_layout/WMS/documents/sales-offers/new")(
  {
    component: CreateSalesOfferPage,
    validateSearch: (search: RawSearch): Search => ({
      warehouseId:
        typeof search.warehouseId === "string" ? search.warehouseId : undefined,
    }),
  },
)

function CreateSalesOfferPage() {
  const navigate = useNavigate()
  const { warehouseId } = Route.useSearch()
  const { createOS, isCreating, isResolvingWarehouses, canCreate } =
    useCreateOS()
  const createStartedRef = useRef(false)

  useEffect(() => {
    if (createStartedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    createStartedRef.current = true
    void createOS({ preferredWarehouseId: warehouseId, replace: true })
  }, [canCreate, createOS, isResolvingWarehouses, warehouseId])

  const handleCancel = () =>
    navigate({
      to: warehouseId
        ? "/WMS/warehouses/$warehouse"
        : "/WMS/documents/document-list",
      ...(warehouseId
        ? { params: { warehouse: warehouseId } }
        : { search: { page: 1, page_size: 50 } }),
    } as any)

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument OS"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu OS..."
      idleLabel="Przygotowywanie edycji dokumentu OS..."
    />
  )
}
